module.exports = global["Components"] = require("-!C:\\BuildAgent\\work\\f521ee62a9405082\\src\\Spurs.v8\\Frontend\\node_modules\\eslint-loader\\index.js??ref--0-0!.\\index.js");


// WEBPACK FOOTER //
// ./src/components/index.js